export default __webpack_public_path__ + "static/media/2268_closed.8e801393.jpg";